// extracted by mini-css-extract-plugin
module.exports = {"left":"AppContainer_left__8clJu"};